import { createFileRoute } from "@tanstack/react-router";
import { PolicyLayout, PolicySection } from "@/components/skl/PolicyLayout";

export const Route = createFileRoute("/returpolitik")({
  head: () => ({
    meta: [
      { title: "Returpolitik — SKL-Flow" },
      { name: "description", content: "Fortrydelses- og returpolitik for digitale ydelser leveret af SKL-Flow." },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Returpolitik — SKL-Flow" },
      { property: "og:description", content: "Regler for fortrydelse, refundering og reklamation ved køb af digitale produkter." },
      { property: "og:type", content: "article" },
    ],
    links: [{ rel: "canonical", href: "https://sklflow.com/returpolitik" }],
  }),
  component: Returpolitik,
});

function Returpolitik() {
  return (
    <PolicyLayout title="Returpolitik" updated="5. juli 2026">
      <PolicySection title="1. Digitale ydelser">
        <p>
          SKL-Flow leverer digitale produkter og skræddersyede hjemmeside-ydelser. Da der er tale om
          digitalt indhold og tjenesteydelser, der ikke leveres på et fysisk medium, kan produktet i
          sagens natur ikke returneres fysisk. Denne returpolitik beskriver derfor de regler, der gælder
          for fortrydelse, refundering og reklamation.
        </p>
      </PolicySection>

      <PolicySection title="2. Fortrydelsesret for forbrugere">
        <p>
          Forbrugere har som udgangspunkt 14 dages fortrydelsesret ved fjernsalg i henhold til
          forbrugeraftalelovens kapitel 4. Fortrydelsesretten regnes fra den dag, aftalen blev indgået.
        </p>
        <p>
          Fortrydelse skal meddeles skriftligt til emilsklanderandersen@gmail.com inden fristens udløb. Du kan
          anvende standardfortrydelsesformularen fra forbrugeraftalelovens bilag 3, men det er ikke et
          krav.
        </p>
      </PolicySection>

      <PolicySection title="3. Bortfald af fortrydelsesret ved påbegyndt levering">
        <p>
          Ved levering af digitalt indhold og tjenesteydelser bortfalder fortrydelsesretten, når levering
          er påbegyndt med Kundens forudgående udtrykkelige samtykke og anerkendelse af, at
          fortrydelsesretten dermed ophører, jf. forbrugeraftalelovens § 18, stk. 2, nr. 13 og § 18, stk. 2,
          nr. 2.
        </p>
        <p>
          Ved bestilling af et hjemmeside-udkast eller anden digital ydelse anses Kunden for at have
          givet dette samtykke, da udarbejdelsen af udkastet påbegyndes straks efter modtagelse af
          nødvendige oplysninger.
        </p>
      </PolicySection>

      <PolicySection title="4. Erhvervskunder">
        <p>
          Fortrydelsesretten gælder ikke for erhvervsdrivende (B2B), medmindre andet er skriftligt
          aftalt.
        </p>
      </PolicySection>

      <PolicySection title="5. Refundering">
        <p>
          Såfremt fortrydelse er gyldigt gjort gældende, og betalingen er modtaget, refunderes beløbet
          uden unødig forsinkelse og senest 14 dage efter, at vi har modtaget meddelelsen om
          fortrydelse. Refundering sker via samme betalingsmiddel, som blev anvendt ved den
          oprindelige transaktion, medmindre andet udtrykkeligt er aftalt.
        </p>
        <p>
          Hvis levering af den digitale ydelse allerede er påbegyndt med Kundens samtykke som nævnt
          i punkt 3, refunderes betalingen ikke.
        </p>
      </PolicySection>

      <PolicySection title="6. Reklamation ved mangler">
        <p>
          Forbrugere har 24 måneders reklamationsret på digitale produkter i henhold til køberetlige
          regler. Reklamation skal ske inden for rimelig tid efter, at manglen er konstateret, og senest
          to måneder efter opdagelsen betragtes som rettidig.
        </p>
        <p>
          Reklamationsretten dækker mangler, der forelå ved leveringen, og som ikke skyldes Kundens
          egne ændringer, fejlagtige brug eller indgreb fra tredjepart. Berettigede reklamationer
          afhjælpes ved omlevering, afhjælpning, forholdsmæssigt afslag eller ophævelse af aftalen
          afhængigt af manglens karakter.
        </p>
        <p>
          Reklamation rettes til emilsklanderandersen@gmail.com med en tydelig beskrivelse af manglen.
        </p>
      </PolicySection>

      <PolicySection title="7. Klageadgang">
        <p>
          Klager over vores ydelser kan indbringes for Center for Klageløsning, Nævnenes Hus,
          Toldboden 2, 8800 Viborg, jf.{" "}
          <a href="https://www.forbrug.dk" className="underline hover:no-underline">www.forbrug.dk</a>. EU-borgere kan
          desuden anvende EU-Kommissionens online klageportal på{" "}
          <a href="https://ec.europa.eu/consumers/odr" className="underline hover:no-underline">
            ec.europa.eu/consumers/odr
          </a>
          .
        </p>
      </PolicySection>

      <PolicySection title="8. Kontakt">
        <p>Alle henvendelser vedrørende fortrydelse, refundering og reklamation rettes til:</p>
        <p>
          SKL-Flow
          <br />
          E-mail: emilsklanderandersen@gmail.com
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
